import Vue from 'vue'
import Vuex from 'vuex'
import { getToken,getCompanyId } from '@/utils/auth.js'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    TAG:'',                               //IsAppPosition:用app内的定位 NoAppPosition:不用app内的定位    标识符(区分从app跳转过来时定位一直是app内的定位，在app内h5无法选择搜索定位)  
    access_token: getToken(),             //用户的token存在cookie里
    userBusRoute: {
      companyId:getCompanyId(),           //运力公司    62EDEC2F2B2D34FB
      driverId:'',                        //司机编号
      startCity: '',                      //起点城市
      start: null,                        //用户详细起点
      startAdcode: null,                  //起点区域编号
      startLat: null,                     //终点伪度
      startLon: null,                     //终点经度
      
      endCity: '',                        //结束城市
      end: null,                          //用户详细终点
      endAdcode: null,                    //终点区域编号
      endLat: null,                       //终点伪度
      endLon: null,                       //终点经度
      peopleCounting: null,               //上车人数
      peopleText:null,

      time: null,                         //上车时间
      timeStart: null,                    //预约开始时间
      timeEnd: null,                      //预约结束时间
      receiveAddress: null,               //当前下单的位置（不是必须项） 
      receiveLat: null,                   //当前下单的伪度
      receiveLon: null,                   //当前下单经度      
    },

  },
  mutations: {
    UpdataStart(state, obj) {
      state.userBusRoute = obj
    },
	
  },
  actions: {
  },
  modules: {
  },
  getters:{
    token:state => state.access_token
  }
})

